<template>
  <div>
    <!-- <p style="font-size:16px;">获取用户ID信息</p> -->
    <p style="font-size:16px;">正在跳转...</p>
  </div>
</template>

<script>

import { getChannelUserId, getPayOrderInfo } from '@/api/api'
import wayCodeUtils from '@/utils/wayCode'
import channelUserIdUtil from '@/utils/channelUserId'
import config from "@/config";
export default {
  components: {
  },
  mounted() {
    console.log("正在跳转", this.$route.params, this.$route.query)

    const allQuery = Object.assign({}, this.searchToObject(), this.$route.query)
    console.log(allQuery)

    const that = this;
    getChannelUserId(allQuery).then(res => {
      console.log(res)
      channelUserIdUtil.setChannelUserId(res);
      channelUserIdUtil.setUserAuthCode(allQuery.userAuthCode);

      getPayOrderInfo().then(orderInfo => {
        const payWay = wayCodeUtils.getPayWay();
        const routeName = orderInfo.payOrderId ? payWay.fixedRouteName : payWay.routeName;
        this.$router.push({ name: routeName });
      }).catch(err => {
        that.$router.push({ name: config.errorPageRouteName, params: { errInfo: err.msg } });
      });
    }).catch(res => {
      that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } })
    });
  },
  methods: {
    searchToObject: function() {
      let result = {};

      // 标准 query string 解析（?key=value&...）
      if (window.location.search) {
        let pairs = window.location.search.substring(1).split("&");
        for (let i in pairs) {
          if (pairs[i] === "") continue;
          let pair = pairs[i].split("=");
          result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
        }
      }

      // 银联回调兼容：银联 OAuth 直接在 URL 末尾拼接 &userAuthCode=xxx&respCode=00（无 ? 前缀）
      // 需要从完整 URL 中提取这些参数
      if (!result.userAuthCode) {
        let fullUrl = window.location.href;
        let authMatch = fullUrl.match(/[&?]userAuthCode=([^&]*)/);
        let respMatch = fullUrl.match(/[&?]respCode=([^&]*)/);
        if (authMatch) result.userAuthCode = decodeURIComponent(authMatch[1]);
        if (respMatch) result.respCode = decodeURIComponent(respMatch[1]);

        // 兜底：从 pathname 中解析（银联 &key=val 会变成路径的一部分）
        if (!result.userAuthCode) {
          let path = window.location.pathname + window.location.hash;
          let pathAuthMatch = path.match(/&userAuthCode=([^&]*)/);
          let pathRespMatch = path.match(/&respCode=([^&]*)/);
          if (pathAuthMatch) result.userAuthCode = decodeURIComponent(pathAuthMatch[1]);
          if (pathRespMatch) result.respCode = decodeURIComponent(pathRespMatch[1]);
        }
      }

      return result;
    }
  }
}
</script>
